import React from 'react'
import intl from 'react-intl-universal'

import AlertBox from 'components/authentication/AlertBox'
import Input from 'components/shared/input/Input'
import FacebookButton from 'components/authentication/FacebookButton'
import OrLine from 'components/authentication/OrLine'
import { Button, FormGroup } from 'components/qstrap'
import API from 'utils/API'
import AccessToken from 'utils/AccessToken'
import config from 'config'
import btoaToken from 'utils/btoaToken'
import csrfToken from 'utils/csrfToken'
import triggerEvent from 'utils/dataLayer'

export default class SignUp extends React.Component {
  constructor(props) {
    super(props)

    this.inputs = {}
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleFacebook = this.handleFacebook.bind(this)

    this.fields = ['first_name', 'last_name', 'email', 'username', 'password']
  }

  attributes() {
    const hash = {}
    this.fields.map(field => hash[field] = this.inputs[field].value)
    return hash
  }

  isValid() {
    this.fields.map(field => this.inputs[field].validate())
    return !this.fields.map(field => !!this.inputs[field].validity()).includes(false)
  }

  login() {
    const hash = this.attributes()
    const token = btoaToken(hash.email, hash.password)
    const options = { headers: { Authorization: `Basic ${token}` } }
    const data = {
      client_id: config.client_id,
      client_secret: config.client_secret,
      response_type: 'json',
    }

    API.post(API.endPoints().auth.login, data, options).then((response) => {
      AccessToken.set(response.data.access_token, false)
      this.acceptTermsAndConditions(() => {
        triggerEvent('ga/signup/daftar')
        window.location = '/signup/application'
      })
    })
  }

  handleSubmit(e) {
    localStorage.removeItem('aptitude_answers')
    localStorage.removeItem('aptitude_page')

    e.preventDefault()
    this.loader.classList.remove('hide')

    if (this.isValid()) {
      const hash = this.attributes()
      const data = {
        client_id: config.client_id,
        client_secret: config.client_secret,
        response_type: 'json',
        first_name: hash.first_name,
        last_name: hash.last_name,
        email: hash.email,
        username: hash.username,
        password: hash.password,
        registered_from: 'campus',
        country_code: 'ID',
      }

      API.post(API.endPoints().auth.register, data).then(() => {
        this.login()
      }).catch((error) => {
        error.response.data.errors.forEach((value) => {
          const input = this.inputs[value.field]
          input.setState(() => ({ clientSideErrors: [value.code] }))
        })
        this.registerFailedAlert.classList.remove('hide')
        this.loader.classList.add('hide')
      })

      return hash
    }
    return this.loader.classList.add('hide')
  }

  handleFacebook(fbResponse) {
    this.loader.classList.remove('hide')
    this.fbName = fbResponse.name

    this.inputs.first_name.setState({ value: fbResponse.name })
    this.inputs.first_name.validate()

    this.inputs.email.setState({ value: fbResponse.email })
    this.inputs.email.validate()

    API.get(API.endPoints().auth.facebook, {
      facebook_token: fbResponse.accessToken,
      client_id: config.client_id,
      registered_from: 'campus',
    }).then((response) => {
      AccessToken.set(response.data.access_token, false)
      this.acceptTermsAndConditions(() => {
        window.location = '/signup/application'
      })
    }).catch(() => {
      this.loader.classList.add('hide')
    })
  }

  acceptTermsAndConditions(cb) {
    const options = {
      headers: {
        'X-CSRF-Token': csrfToken(),
      },
    }

    API.post(API.endPoints().common.term_agreement, {}, options).then(cb)
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="bold m-b-md">{intl.get('account.register_title')}</div>

        <FacebookButton
          callback={this.handleFacebook}
          fbName={this.fbName}
          onClick={() => triggerEvent('ga/signup/facebookconnect')}
        />
        <OrLine />

        <Input
          ref={c => this.inputs.first_name = c}
          name="first_name"
          label={intl.get('account.first_name')}
          validations={['required']}
          embedErrorsInfo
        />

        <Input
          ref={c => this.inputs.last_name = c}
          name="last_name"
          label={intl.get('account.last_name')}
          validations={['required']}
          embedErrorsInfo
        />

        <Input
          ref={c => this.inputs.email = c}
          icon="mail"
          name="email"
          label={intl.get('account.email')}
          validations={['required', 'email']}
          embedErrorsInfo
        />

        <Input
          ref={c => this.inputs.username = c}
          icon="account"
          name="username"
          label={intl.get('account.username')}
          validations={['required', 'username']}
          embedErrorsInfo
        />

        <Input
          ref={c => this.inputs.password = c}
          name="password"
          type="password"
          icon="password"
          label={intl.get('account.password')}
          validations={['required', 'contains_text_and_number', 'min_length']}
          embedErrorsInfo
        />

        <FormGroup className="m-t-lg text-center bold" check>
          { intl.getHTML('account.agreement_notice') }
        </FormGroup>

        <FormGroup className="m-t-lg">
          <AlertBox setRef={c => this.registerFailedAlert = c} text={intl.get('account.already_have_account')} />
        </FormGroup>

        <FormGroup className="m-t-lg" check>
          <Button color="primary" type="submit" block onClick={this.handleSubmit} className="icon-loading-container">
            <i className="icon icon-loading icon-loading-center hide" ref={c => this.loader = c} />
            {intl.get('account.sign_up')}
          </Button>
        </FormGroup>

        <hr />

        <FormGroup className="m-t-lg text-center" check>
          <div>{intl.get('account.already_have_quipper_account')}</div>
          <div>
            <a className="bold" href="/signin" onClick={() => triggerEvent('ga/signup/click/masuk')}>
              {intl.get('account.click_here_to_login')}
            </a>
          </div>
        </FormGroup>
      </form>
    )
  }
}
